<template>
  <p class="InstructionsBlock" v-html="block.config.text"></p>
</template>

<script>
  import IriadeBlockMixin from '../IriadeBlockMixin'

  export default {
    mixins: [IriadeBlockMixin]
  }
</script>

<style lang="scss"
       type="text/scss">
  .InstructionsBlock {
    font-size: 18px;
    font-weight: 500;
    white-space: pre-line;
  }
</style>
